// Copyright (c) 2016 Deere & Company

import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import {translate} from '../../../shared/services/translation-service';

export function getPinCrossReferenceColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'requestPin',
            field: 'requestPin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('INPUT_PIN'),
            width: 200
        },
        {

            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'responsePin',
            field: 'responsePin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('OUTPUT_PIN'),
            width: 200
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/report-services/column-definitions.js